import React from 'react';
import * as Backend from '../backend.js';
import * as util from '../other/util.js';
import PlanetHeaderView from "./planet-header-view.js";
import PlanetConstructionView from './planet-construction-view.js';
import PlanetShipDesignView from './planet-ship-design-view.js';
import PlanetShipyardView from './planet-shipyard-view.js';
import PlanetShipDockView from './planet-ship-dock-view.js';
import PlanetResourceView from './planet-resource-view.js';
import ShipCollection from '../share/ship-collection.js';

// The root view for inspecting an owned planet
// It has the PlanetHeader on top and displays the different construction, ship, resource views below
class PlanetView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    refreshState() {
        let x = this.props.params.x;
        let y = this.props.params.y;
        let z = this.props.params.z;

        Backend.getPlanetDetails(x, y, z, (res) => {
            if (res.planet.owner_id !== util.getGPS().player_id) {
                this.props.navigate('/game/solar-system' + util.getPlanetUrl(this.props.match.params));
                return;
            }

            res.planet.stationed_ships = new ShipCollection(res.planet.stationed_ships);
            this.setState({ planet: res.planet });
        });
    }

    render() {
        if (!this.hasCurrentState()) {
            return (<util.LoadingBar2 />);
        }

        let planet = this.state.planet;
        let active_tab = this.props.activeTab;
        return (
            <div>
                <PlanetHeaderView planet={planet} activePage={active_tab} />
                {this._getActiveTab(planet, active_tab)}
                <util.JsonDebug obj={planet} />
            </div>
        );
    }

    onUpdatePlanet(planet) {
        planet.stationed_ships = new ShipCollection(planet.stationed_ships); // Transform dumb json data into an object with functions
        this.setState({ planet: planet });
    }

    _getActiveTab(planet, active_tab) {
        switch (active_tab) {
            case "planet-construction":
                return <PlanetConstructionView planet={planet} onUpdatePlanet={p => this.onUpdatePlanet(p)} />
            case "planet-ship-construction":
                return <PlanetShipyardView planet={planet} onUpdatePlanet={p => this.onUpdatePlanet(p)} />
            case "planet-ship-design":
                return <PlanetShipDesignView planet={planet} onUpdatePlanet={p => this.onUpdatePlanet(p)}
                    playerTechnologies={util.getGPS().research.technologies} />
            case "planet-ships":
                return <PlanetShipDockView planet={planet} onUpdatePlanet={p => this.onUpdatePlanet(p)} />
            case "planet-resources":
                return <PlanetResourceView planet={planet} onUpdatePlanet={p => this.onUpdatePlanet(p)} />
            default:
                return <div>Error</div>
        }
    }
}

export default util.withParamsAndNavigation(PlanetView);
